import { render } from "./SiteMain.vue?vue&type=template&id=521471e1&scoped=true"
import script from "./SiteMain.vue?vue&type=script&lang=js"
export * from "./SiteMain.vue?vue&type=script&lang=js"

import "./SiteMain.vue?vue&type=style&index=0&id=521471e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521471e1"]])

export default __exports__